'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Dots = function Dots(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 512 512' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M448.046 191.984c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.015 64.015c35.337 0 64.015-28.647 64.015-64.016s-28.678-64.016-64.015-64.016zm-192.046 0c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.016 64.015 64.015-28.647 64.015-64.016-28.679-64.016-64.016-64.016zm-192.047 0C28.616 191.984-.063 220.631-.063 256s28.679 64.015 64.016 64.015 64.016-28.647 64.016-64.016-28.679-64.016-64.016-64.016z'
      })
    )
  );
};
/*eslint-enable */

exports.default = Dots;
//# sourceMappingURL=Dots.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Dots.js